module.exports = __webpack_public_path__ + "img/img_face_accreditation.d48a01e1.svg";